export default __webpack_public_path__ + "static/media/image-from-above.f316f3f3.jpg";